import request from '../utils/request'

//合同模板列表
// export function templateList(limit,page) {
//     return request.post('/api/contract_tem_list',{'limit':limit,"page":page})
// }
export function templateList(data){
    return request({
        url:'/api/contract_tem_list',
        method:'post',
        data
    })
}
//启用禁用按钮
export function switchBtn(tpl_auth_id,is_use) {
    return request.post('/api/contract_tem_enable',{"tpl_auth_id":tpl_auth_id,"is_use":is_use})
}
//创建合同详情
export function createContract(customBizNum) {
    return request.post('/api/create_contbytpl_one_detail',{"customBizNum":customBizNum})
}
//下一步根据模板创建合同
export function nextStep(customBizNum,doc_title,contract_sn,expire_time,signers) {
    return request.post('/api/save_contbytpl_one',{"customBizNum":customBizNum,"doc_title":doc_title,"contract_sn":contract_sn,"expire_time":expire_time,"signers":signers})
}
//模板链接
export function templateLink(sn) {
    return request.post('/api/create_contbytpl_two_url',{"sn":sn})
}
//填写合同模板链接
export function fillInTemplate(tpl_auth_id) {
    return request.post('/api/contract_tem_write_url',{"tpl_auth_id":tpl_auth_id})
}
//删除发送失败按钮
export function sendFailure(signer_list_id) {
    return request.post('/api/contract_sign_delete',{"signer_list_id":signer_list_id})
}
//合同模板（接口版）
export function templateDetails(tpl_auth_id) {
    return request.post('/api/conttpl_component_detail',{"tpl_auth_id":tpl_auth_id})
}
//保存数据（接口版）
export function interfaceSave(tpl_auth_id,component_data) {
    return request.post('/api/submit_conttpl_component_data',{"tpl_auth_id":tpl_auth_id,"component_data":component_data})
}
//保存合同签署方   （接口）
export function signatureInterface(customBizNum,doc_title,contract_sn,expire_time,signers) {
    return request.post('/api/save_contbytpl_sign',{"customBizNum":customBizNum,"doc_title":doc_title,"contract_sn":contract_sn,"expire_time":expire_time,"signers":signers})
}
//预览合同
export function previewContract(customBizNum) {
    return request.post('/api/cont_file_preurl',{"customBizNum":customBizNum})
}
//保存草稿
export function saveDraft(tpl_auth_id,notes,component_data) {
    return request.post('/api/save_conttpl_draft',{"tpl_auth_id":tpl_auth_id,"notes":notes,"component_data":component_data})
}
//上一步修改数据后不扣合同份数
export function submitData(customBizNum,component_data) {
    return request.post('/api/again_conttpl_component_data',{"customBizNum":customBizNum,"component_data":component_data})
}
//使用草稿
export function draftList(limit,page) {
    return request.post('/api/conttpl_draft_list',{"limit":limit,"page":page})
}
//草稿详情
export function draftDetails(draft_id) {
    return request.post('/api/conttpl_draft_detail',{"draft_id":draft_id})
}
//草稿删除
export function deleteManuscript(draft_id) {
    return request.post('/api/delete_conttpl_draft',{"draft_id":draft_id})
}
//在线合同模板链接
export function onlineContract(tpl_auth_id) {
    return request.post('/api/contract_tem_write_url_pay',{"tpl_auth_id":tpl_auth_id})
}
//合同模式为支付模式 合同签署方详情
export function paymentModeDetails(customBizNum) {
    return request.post('/api/create_contbytpl_one_detail_pay',{"customBizNum":customBizNum})
}
//合同支付模式 在线类型发起签署
export function onlineSignPay(customBizNum,doc_title,contract_sn,expire_time,money,signers) {
    return request.post('/api/save_contbytpl_one_pay',{"customBizNum":customBizNum,"doc_title":doc_title,"contract_sn":contract_sn,"expire_time":expire_time,"money":money,"signers":signers})
}
//合同支付模式 表单类型发起签署
export function formSignPay(customBizNum,doc_title,contract_sn,expire_time,money,signers) {
    return request.post('/api/save_contbytpl_sign_pay',{"customBizNum":customBizNum,"doc_title":doc_title,"contract_sn":contract_sn,"expire_time":expire_time,"money":money,"signers":signers})
}
//批量删除草稿
export function deleteDraft(data) {
    return request({
        url:'/api/batch_delete_conttpl_draft',
        method:'post',
        data
    })
}
